import { queryVerifyInfo } from "@shared/apis/user";
import { cachify } from "@shared/core/cache";
import "@shared/dom-polyfills/dataset";
import "@shared/dom-polyfills/classList";

const getVerifyInfo = cachify(userId => queryVerifyInfo(userId));

export function loadAndRenderVerifyInfo(userId) {
  userId = Number(userId) || 0;
  if (!userId) return;
  const root = document.querySelector(`.verify-box[data-user="${userId}"]`);
  if (!root) return;

  root.classList.add("verify-box--loading");
  getVerifyInfo(userId).then(data => {
    root.classList.remove("verify-box--loading");
    const verified = data.verifyStatus === 5;
    if (verified) {
      root.classList.remove("verify-box--unverified");
    } else {
      root.classList.add("verify-box--unverified");
    }
    root.querySelector(`.verify-info__status`).innerHTML = verified ? "已实名认证" : "未实名认证";
    root.querySelector(`.verify-info__realname`).innerHTML = data.name;
    root.querySelector(`.verify-info__id-no`).innerHTML = data.identityNo;
  });
}

export function setLoadTrigger(node, { events } = {}) {
  if (!node) return;
  events = events || ["click", "mouseover"];
  events.forEach(function(eventName) {
    node.addEventListener(eventName, _loadTrigger);
  });
}

function _loadTrigger(e) {
  const dataset = e.currentTarget.dataset || e.target.dataset || {};
  const userId = dataset.user || dataset.userId;
  loadAndRenderVerifyInfo(userId);
}

require("./verify-box.less");